import * as yup from "yup";

export const RemediacionesSchema = yup.object().shape({
  aprobadas: yup
    .boolean()
    .required("errors.remediaciones.aprobadas.required")
    .default(false),
  disposicion: yup
    .string()
    .max(20, "errors.remediaciones.disposicion.max")
    .when("aprobadas", {
      is: true,
      then: (schema) =>
        schema
          .required("errors.remediaciones.disposicion.requireds")
          .default(""),
      otherwise: (schema) => schema.default(null),
    }),
});
